<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.077"
    height="23.848"
    viewBox="0 0 24.077 23.848"
  >
    <g transform="translate(-1100.719 -578.327)">
      <path
        d="M1108.386,602.175l-7.667-7.554,13.233-13.261,6.457,1.061,1.5,6.2Zm-6.249-7.56,6.243,6.15L1120.8,588.31l-1.21-5.01-5.3-.869Z"
      />
      <g>
        <circle
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(1116.428 584.01)"
          fill="#fff"
        />
        <path
          d="M1117.928,587.01a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,1117.928,587.01Zm0-2a.5.5,0,1,0,.5.5A.5.5,0,0,0,1117.928,585.01Z"
        />
      </g>
      <path
        d="M1120.2,586.888a5.7,5.7,0,0,1-1.253-.135l.222-.975c.15.034,3.7.794,4.47-2.42.486-2.04-.173-3.321-1.959-3.808l-.117-.033a3.317,3.317,0,0,0-4.231,2.022,3.267,3.267,0,0,0-.155.629l-.99-.145a4.395,4.395,0,0,1,.2-.817,4.324,4.324,0,0,1,5.508-2.633c2.383.65,3.331,2.428,2.714,5.018A4.2,4.2,0,0,1,1120.2,586.888Z"
      />
      <g style="isolation: isolate">
        <text
          transform="translate(1107.384 598.44) rotate(-45)"
          font-size="4.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
          style="isolation: isolate"
        >
          <tspan x="0" y="0">BRAND</tspan>
        </text>
      </g>
    </g>
  </svg>
</template>
